import { userService } from "./user.service";

// Анкета пользователя. Глобальная, не привязана к конференции: ни одна из ручек
// не принимает conference_id, значения лежат в user.info.anketa. К конференции
// привязан только выбор, какие поля обязательны при покупке билета.
export const anketaService = {
  getAnketaEditor,
  saveAnketa,
};

// GET api/user/anketa-editor[?scope=vcard] → { fields: [{ "<id>": {title, type, items} }], anketa: {id: value} }
// type: text | radio | checkbox. Форма полей — та, которую ждёт ClientPages/UserInfoDialog.
//
// scope=vcard — только поля, попадающие в визитку (список кодов VCardBuilder::CODES
// живёт на бэке, фронт их не знает). Без scope — полный список, как в кабинете.
function getAnketaEditor(onSuccess, onError, scope) {
  userService.getWrapper(
    "api/user/anketa-editor" + (scope ? "?scope=" + scope : ""),
    (data) => onSuccess(data.data),
    onError
  );
}

// POST api/anketa с телом { [fieldId]: value } → { anketa: {...} }
function saveAnketa(values, onSuccess, onError) {
  userService.postWrapper(
    "api/anketa",
    values,
    (data) => onSuccess(data.data),
    onError
  );
}
